import { render, staticRenderFns } from "./alliance-members-pagination.vue?vue&type=template&id=3672e9a6&scoped=true&"
import script from "./alliance-members-pagination.vue?vue&type=script&lang=js&"
export * from "./alliance-members-pagination.vue?vue&type=script&lang=js&"
import style0 from "./alliance-members-pagination.vue?vue&type=style&index=0&id=3672e9a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672e9a6",
  null
  
)

export default component.exports